import { render } from "./ViewPrivacyStatement.vue?vue&type=template&id=5c0f9a8c"
import script from "./ViewPrivacyStatement.vue?vue&type=script&lang=js"
export * from "./ViewPrivacyStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__